(() => {
  const wishlistKey = 'shiulii-wishlist-products';

  const readWishlist = () => {
    try {
      const value = JSON.parse(localStorage.getItem(wishlistKey) || '[]');
      return Array.isArray(value) ? value.map(String) : [];
    } catch (error) {
      return [];
    }
  };

  const saveWishlist = (items) => {
    localStorage.setItem(wishlistKey, JSON.stringify(items));
  };

  const initWishlist = (root = document) => {
    root.querySelectorAll('[data-shiulii-wishlist]').forEach((button) => {
      if (button.dataset.initialised === 'true') return;

      const productId = String(button.dataset.productId || '');
      const label = button.querySelector('[data-wishlist-label]');

      const sync = () => {
        const active = readWishlist().includes(productId);

        button.classList.toggle('is-active', active);
        button.setAttribute('aria-pressed', String(active));

        if (label) {
          label.textContent = active ? 'Wishlisted' : 'Wishlist';
        }
      };

      button.addEventListener('click', () => {
        const current = readWishlist();

        const next = current.includes(productId)
          ? current.filter((id) => id !== productId)
          : [...current, productId];

        saveWishlist(next);
        sync();
      });

      sync();
      button.dataset.initialised = 'true';
    });
  };

  const initPincode = (root = document) => {
    root.querySelectorAll('[data-shiulii-pincode-form]').forEach((form) => {
      if (form.dataset.initialised === 'true') return;

      const input = form.querySelector('input');
      const result = form.parentElement.querySelector(
        '[data-shiulii-pincode-result]'
      );

      form.addEventListener('submit', (event) => {
        event.preventDefault();

        const pincode = String(input?.value || '').trim();

        if (!/^[1-9][0-9]{5}$/.test(pincode)) {
          result.textContent =
            'Please enter a valid 6-digit Indian pincode.';
          result.style.color = '#a32929';
          return;
        }

        result.textContent =
          'Delivery is usually estimated within 5–7 business days. Final availability is confirmed at checkout.';

        result.style.color = '#138a67';
      });

      form.dataset.initialised = 'true';
    });
  };

  const init = (root = document) => {
    initWishlist(root);
    initPincode(root);
  };

  if (document.readyState === 'loading') {
    document.addEventListener(
      'DOMContentLoaded',
      () => init(document),
      { once: true }
    );
  } else {
    init(document);
  }

  document.addEventListener('shopify:section:load', (event) => {
    init(event.target);
  });

  document.addEventListener('product-info:loaded', (event) => {
    init(event.target);
  });
})();